import Translated from "./Translated";
import useOpenPrivacyPolicy from '../../hooks/useOpenPrivacyPolicy';

const DataPrivacyNote = (props) => {
  const handlePrivacyPolicyClick = useOpenPrivacyPolicy();

  return (
    <div className={props.className}>
      <Translated
        translationKey="data_privacy_label"
        className="touchable"
        onClick={handlePrivacyPolicyClick}
      />
    </div>
  );
};

export default DataPrivacyNote;
